export const reviews = [
	{
		id: 1,
		name: "Sharon",
		role: "Freelancer",
		rating: 4,
		avatar: "/images/women.jpeg",
		review:
			"Very satisfied. I knew when the item was shipped and expected to receive. Looks beautiful just like in the picture. The customer service answered all my questions satisfactorily",
	},
	{
		id: 2,
		name: "Sharon",
		role: "Freelancer",
		rating: 4,
		avatar: "/images/women.jpeg",
		review:
			"Very satisfied. I knew when the item was shipped and expected to receive. Looks beautiful just like in the picture. The customer service answered all my questions satisfactorily",
	},
	{
		id: 3,
		name: "Sharon",
		role: "Freelancer",
		rating: 4,
		avatar: "/images/women.jpeg",
		review:
			"Very satisfied. I knew when the item was shipped and expected to receive. Looks beautiful just like in the picture. The customer service answered all my questions satisfactorily",
	},
];

export const successStories = [
	{
		id: 1,
		name: "Bala Raju & Udaya",
		platform: "Annapurna Marriages",
		image: "/images/couple.png",
		testimonial:
			"Bala Raju and Udaya are a fun-loving couple who met each other on Annapurna Marriages.When I looked at Udaya's her profile on Annapurna Marriages...",
	},
	{
		id: 2,
		name: "Couple Name",
		platform: "Annapurna Marriages",
		image: "/api/placeholder/250/250",
		testimonial:
			"Success story example text. This is a placeholder for additional success stories that would appear in the carousel.",
	},
	{
		id: 3,
		name: "Another Couple",
		platform: "Annapurna Marriages",
		image: "/api/placeholder/250/250",
		testimonial:
			"Another success story example. This is a placeholder for additional success stories that would appear in the carousel.",
	},
];

export const plans = [
	{
		title: "SUN",
		price: "5000",
		duration: "6 Months",
		contactsAllowed: "25",
	},
	{
		title: "MOON",
		price: "5000",
		duration: "6 Months",
		contactsAllowed: "25",
	},
	{
		title: "MARS",
		price: "5000",
		duration: "6 Months",
		contactsAllowed: "25",
	},
];
